
import { useParams, useNavigate } from 'react-router-dom';
import './ProjectPage.css';
import { subset } from 'semver';
import { useEffect } from 'react';


const projectData = {
  gardenia: {
    title: 'Gardenia 🌱',
    subtitle: 'AR Gardening Game',
    images: [],
    summary: 'An AR garden game where players control the growth of flowers by tangible interactions, creating an immersive experience.',
    description: `
    <div class="content-container">
      <div class="text-section">
        <p>
          <em>Gardenia</em> is an <strong>augmented reality gardening game</strong> where players grow virtual flowers under varying weather conditions.</p>
        <p>
          The game's mechanics include real-time growth rate adjustments, dynamic environmental effects, and audio-visual 
          feedback to create an engaging experience. Players control the weather and use physical objects to perform various actions.
        </p>
        <p>
          The game's primary goal is to <strong>grow three types of flowers to fill a flower basket</strong> by satisfying their specific needs: Sunny Bloom, Rainy Petal and Frost Flower. 
        </p>

        <a href="https://drive.google.com/file/d/1PqUsF3OP8mYoQ3nxj2Vm4HLPrubLYX36/view?usp=sharing" target="_blank" rel="noreferrer">
          <button class="visit-button"><strong>Watch the full demo!</strong></button>
        </a>
     </div>
      <div class="image-stack">
          <video controls autoplay muted loop playsinline class="goodreads-image1">
            <source src="/images/gardenia1.mp4" type="video/mp4">
            Your browser does not support the video tag.
          </video>
      </div>
    </div>
    <div class="content-container">
      <div class="image-stack">
          <video controls autoplay muted loop playsinline class="goodreads-image1">
            <source src="/images/gardenia2.mp4" type="video/mp4">
            Your browser does not support the video tag.
          </video>
      </div>

      <div class="text-section">
         <p><strong>Physical objects in our game:</strong></p>
        <ul>
          <li>Board with 3 QR codes to represent plantation areas</li>
          <li>3 types of seed bags that include image targets for their corresponding flower</li>
          <li>Small water cup with its corresponding image target</li>
          <li>A basket with its corresponding image target</li>
        </ul>
     </div>
    </div>

    `,
    links: [
     // { name: 'Visit Video Demo!', url: 'https://drive.google.com/file/d/1PqUsF3OP8mYoQ3nxj2Vm4HLPrubLYX36/view?usp=sharing' },
    ],
    tags: ['Game Design', 'Extended Reality'],
  },
  frog: {
    title: 'The Jogger Frog 🐸',
    subtitle: 'AR Fitness Coach Previsualization',
    images: [],
    summary: 'An AR fitness coach who motivates you to move!',
    description: `
   <div class="content-container">
    <div class="text-section">
      <p>
        <em>Jogger Frog</em> is an <strong>augmented reality fitness project</strong> to make daily exercise more fun and engaging. 
        The app features a frog companion that encourages users to stay active by collecting coins and jumping over virtual 
        lilypads in real-world environments. 
      </p>

      <p>
        I designed and animated the frog using <strong>3D sculpting, texture painting, and motion tracking techniques</strong>, then integrated the 
        character into an AR experience. The final render combines gamification with physical activity.
      </p>
          
      <p>
        <strong>Tools used:</strong> Blender, CapCut, iMovie, Clideo, Sketchfab assets  
      </p>

      <a href="https://drive.google.com/file/d/1m5azmIjAP7rhf7hIxHlECjNex7XfqEu0/view?usp=sharing" target="_blank" rel="noreferrer">
        <button class="visit-button"><strong>Watch the full movie!</strong></button>
      </a>
    </div>

    <div class="image-stack">
        <video controls autoplay muted loop playsinline class="stacked-img">
          <source src="/images/coins.mp4" type="video/mp4">
          Your browser does not support the video tag.
        </video>
        <video controls autoplay muted loop playsinline class="stacked-img">
          <source src="/images/bravo1.mp4" type="video/mp4">
          Your browser does not support the video tag.
        </video>
    </div>
  </div>

    `,
    links: [
   //   { name: 'Watch the Movie!', url: 'https://drive.google.com/file/d/1m5azmIjAP7rhf7hIxHlECjNex7XfqEu0/view?usp=sharing' },
    ],
    tags: ['Extended Reality'],
  },
  'aura-palette': {
    title: 'Aura Palette 🎨',
    subtitle: 'AI Color Generator: A Design System Case Study',
    images: [],
    summary: '',
    description: ``,
    sections: [
      {
        title: 'Context',
        body: `
        <div class="content-container">
          <div class="text-section">
            <p><em>Aura Palette</em> is a website targeting <strong>designers</strong> that allows them
             to find their <strong>desired color palettes by simply entering a prompt through machine learning</strong>.
            </p>

            <p>This was my CS graduation project with a team of 5 people, completed on June 2023. However, as a technical project focused on speed and
            implementation, it lacked a thoughtful UI/UX design.
            </p>
            <p>
            So <strong>after 2 years, I decided to revisit the project</strong>, now from a <strong>product design perspective.</strong> 
            </p>

            <p>In this case study, I will focus on my <strong>design system implementation</strong> and <strong>UI/UX design</strong>, iterating
            on our software development project.
            </p>
          </div>
          
          <div class="image-stack2">
              <h2>✦ BEFORE ✦</h2>
              <img src="/images/aura-light.png" class="goodreads-image1" />
          </div>
        </div>

        <div class="centered-container1">
        <h2>✦ AFTER ✦</h2>
        <img src="/images/aura-mock.png" class="goodreads-image1 aura-mock" />

        <a href="#interaction-design">
          <button class="visit-button"><strong>Jump to interaction videos ⬇</strong></button>
        </a>

        </div>
      `
      },
      {
        title: 'Timeline',
        body: `
        <div class="timeline">
        <div class="timeline-item">
          <span>Sep 2022</span>
          Ideation of Project
        </div>
        <div class="timeline-item">
          <span>Sep 2022–Jun 2023</span>
          Software Implementation (Front-end, Back-end, ML Algorithms)
        </div>
        <div class="timeline-item">
          <span>Jun 2023</span>
          CS Fair – Aura Palette wins Wide Impact Award (among 36 projects)
        </div>
        <div class="timeline-item">
          <span>Oct–Nov 2025</span>
          UI/UX Design Iteration <strong>✦︎Today's Focus Point!✦︎</strong>
        </div>
      </div>
        `,
      },
      {
        title: 'Design Approach',
        body: `
        <p>
          I started by studying existing design systems, how they were built and organized.</p>
          <p>
          Reading
          <a className="source" href="https://atomicdesign.bradfrost.com/">
          <strong>Brad Frost's "Atomic Design"↗</strong></a>, I was instantly inspired and decided to
          follow his approach. The atomic approach is structured and easy to read, understand and disect complex
          components.
        </p>

        <p>I chose this approach because the color generator app has one core functionality, 
        and the rest can be easily scaled using reusable atoms and molecules. However,
        for a more complex SaaS product, I might explore a different design approach.
        </p>

        <p>
          In this architecture, there are 5 stages: <strong>atoms ▸ molecules ▸ organisms ▸ templates ▸ pages</strong>.
        </p>
        `
    },
    {
      title: 'Atomic Design',
      body: `
      <br>
      <h3>Atoms & Molecules: Simple components</h3>
      <p>
      Atoms are the most simple structure of the design system that consist of texts, icons, buttons...
      Molecules form up with multiple atoms combined.
      With molecules, I tried to create more states of the atoms and combine them in different scenarios.
      </p>

      <img src="/images/atom-molecule.png" class="goodreads-image1" />

      <div class="image-text">
        <div class="text-content">
          <h3>Organisms: Complex components</h3>
          <p>
            These are larger patterns composed of molecules and atoms.
            They form the foundation of layouts such as cards, and sections.
          </p>
        </div>
        <img src="/images/organism.png" alt="Organisms in the design system">
      </div>
      
      <div class="image-text">
        <div class="text-content">
          <h3>Figma Variables</h3>
          <p>
            I created reusable Figma variables to ensure <strong>consistency and scalability</strong>.
          </p>
          <p>
            I mapped these variables to components such as texts, icons, border widths, etc.
          </p>
        </div>
        <img src="/images/variables.png">
      </div>

      `
    },
    {
      title: 'Interaction Design',
      body: `
      <div id="interaction-design">
      <p>
        With my major components settled, it was time to <strong>fix the pain points</strong> in the interaction:
      </p>
      <ul>
        <li><strong>Cluttered layout –></strong> Tools and filters were scattered, disrupting workflow.</li>
        <li><strong>Poor hierarchy –></strong> Key actions like “Generate” and “Edit Color” lacked visual priority.</li>
        <li><strong>Weak focus –></strong> Side panels competed with the main palette area.</li>
        <li><strong>Excess white space –></strong> Layout felt sparse and disconnected.</li>
        <li><strong>Inconsistent interactions –></strong> Editing and adjustment behaviors were unclear.</li>
      </ul>
      <p>
        With many experiments, this process helped me <strong>refine the final look</strong>. I iterated a lot on the initial look of the design system to achieve my UX goals.
      </p>

      <h3>Collapsible Sidebar</h3>
      <p>
  I intentionally designed the layout with a collapsible sidebar to <strong>prioritize the core function</strong> of the color generator: entering a keyword and receiving a palette. 
  This allows users to hide the sidebar for a <strong>focused experience</strong> where the palette takes center stage. When needed, the sidebar can be expanded to access additional features in <strong>one organized space</strong>.
      </p>

      <div class="video-container">
      <video controls autoplay muted loop playsinline class="cropped-video1">
        <source src="/images/sidebar.mp4" type="video/mp4">
        Your browser does not support the video tag.
      </video>
      </div>
      <p> </p>
      <br>
      <h3>Other Interactions with the Sidebar</h3>
      <div class="video-container">
      <video controls autoplay muted loop playsinline class="cropped-video1">
        <source src="/images/other.mp4" type="video/mp4">
        Your browser does not support the video tag.
      </video>
      </div>

      <p> </p>
      <br>
      <h3>Editing Color</h3>
      <div class="video-container">
      <video controls autoplay muted loop playsinline class="cropped-video2">
        <source src="/images/edit-palette.mp4" type="video/mp4">
        Your browser does not support the video tag.
      </video>
      </div>
      <p> </p>
      <br>
      <h3>Simulating Color Blindness</h3>
      <div class="video-container">
      <video controls autoplay muted loop playsinline class="cropped">
        <source src="/images/blindness.mp4" type="video/mp4">
        Your browser does not support the video tag.
      </video>
      </div>
      <p><i>More interaction previews coming soon...</i> ヾ( ˃ᴗ˂ )◞ • *✰</div>
      `
    },{
      title: 'Takeaways',
      body: `
      <p>
      Revisiting <em>Aura Palette</em> two years after its initial development helped me bridge my <strong>engineering and design perspectives</strong>.
      </p>
      
      <p>
      The code-oriented project evolved into a design system case study, demonstrating how thoughtful structure and interaction design can elevate usability and aesthetic coherence.
      </p>
      <p>
      I learned:
      </p>

      <ul>
        <li><strong>Systems thinking →</strong> I learned to design reusable, scalable components through the atomic design approach.</li>
        <li><strong>Figma Proficiency →</strong> I became more confident using Figma for building scalable design systems and translating technical features into intuitive visual experiences.</li>
        <li><strong>Iterative refinement →</strong> Each prototype taught me how hierarchy, spacing, and feedback shape usability.</li>
        <li><strong>Design–development balance →</strong> I gained a stronger understanding of the relation between UI decisions and front-end implementation.</li>
      </ul>

      <p>
      Overall, <em>Aura Palette</em> gave me a chance to merge logic and creativity, and turn our engineering project into a
      human-centered product with a structured design system behind it.
      </p>
      `
    }

  ],
    tags: ['Design System','UI Design', 'Front-end Development'],
    links: [
     // { name: 'Visit Project', url: 'https://aura-palette.vercel.app/' },
    ],
  },
  'goodreads-study': {
    title: 'GoodReads Case Study 📚',
    subtitle: 'A quantitative UX research on book recommendations',
    images: [],
    summary: 'A data-focused use case study of Goodreads. Identifying key friction points through a user testing protocol with 16 participants.',
    info: {
    tasks: ['UX Research', 'Protocol Design', 'Data Analysis'],
    tools: ['Python', 'Cursor Tracker', 'Google Forms'],
    team: ['4 Members'],
    role: ['User Journey Mapping', 'Protocol Design', 'Results Analysis'],
    timeline: 'Nov 2024 – Feb 2025'
  },
    sections: [
  // ——— Non-step sections ———
  {
    title: 'Background',
    subtitle: '',
    body: `
        <div class="content-container">
          <div class="text-section ">  
           <p>As a team of 4 people we evaluated the usability of Goodreads 
           using a mix of <strong>quantitative and qualitative research methods</strong>.</p> 
           
           <p>Our goal was to assess how intuitive, efficient, and satisfying 
           it is for users to discover book recommendations on the platform.</p>
          </div>
        
        </div>

        <div class="content-container centered-container">

        <div class="text-section">
          <article>
            <h3>Problem</h3>
            <p>The platform’s outdated interface creates an <strong>unintuitive and confusing experience for users to find book recommendations.</strong></p>
            <p>Our goal was to evaluate Goodreads, its relevant recommendation features and understand where users struggle most.</p>
            
          </article>
        </div>
        <video controls autoplay muted loop playsinline class="video-section1 good">
          <source src="/images/goodreads.mp4" type="video/mp4">
          Your browser does not support the video tag.
        </video>

        <article>
          <h3>Key Challenges</h3>
          <ul>
            <li>Designing a testing protocol that balanced quantitative precision with qualitative insight</li>
            <li>Measuring navigation efficiency through cursor and task-tracking data without disrupting natural behavior</li>
            <li>Analyzing both cursor tracker and survey data to connect usability issues with user sentiment</li>
            <li>Communicating actionable UX points based on insights</li>
          </ul>
        </article>
      </div>
      `
  },
  {
    title: 'Process',
    subtitle: 'Our research workflow',
    process: [
      { step: '01', phase: 'Understand', items: ['Desk research'] },
      { step: '02', phase: 'Plan', items: ['User Journey Map', 'Goals-Signals-Metrics'] },
      { step: '03', phase: 'Observe', items: ['User Testing Protocol'] },
      { step: '04', phase: 'Analyze', items: ['Data Analysis', 'Insights'] },
    ],
  },
  {
    title: 'Desk Research',
    body: `
      <p>We began with an exploratory review of Goodreads to understand its positioning as the most widely used book-tracking and recommendation platform. Our desk research included competitive benchmarking (<a className="source" href="https://thestorygraph.com/"><strong>StoryGraph↗</strong></a> & <a className="source" href="https://www.librarything.com/">
  <strong>LibraryThing↗</strong></a>), interface heuristics, and analysis of app-store reviews and forum discussions.</p> 
      <p>Recurring complaints pointed to <strong>difficulty discovering new books, inconsistent navigation, and cluttered interfaces</strong>. These insights framed our initial hypotheses around usability challenges related to information hierarchy and task efficiency in book discovery and shelf management.</p>
    `
  },
  {
    title: 'User Journey Map',
    body: `
      <p>We mapped the user journey from discovery to retention to highlight key pain points experienced by users at different stages. We identified the task of “finding book recommendations” as a key pain point the users face.</p>
         <img src="/images/userjourney.png" alt="User Journey Map" class="goodreads-image1" />
      `
  },
  {
    title: 'Goals-Signals-Metrics',
body: `
  <p>Before data collection, we identified the goals, signals, and metrics, which ensured that our data collection and analysis were focused and purposeful.</p>

  <table class="gsm-table">
    <thead>
      <tr>
        <th>Goals</th>
        <th>Signals</th>
        <th>Metrics</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>Identify pain points and inefficiencies on the Goodreads website.</td>
        <td>
          <ul>
            <li>User reported frustration or confusion</li>
            <li>User gave a low rating to a feature</li>
          </ul>
        </td>
        <td>
          <ul>
            <li>Average time spent locating different sections</li>
            <li>Frequency of interactions per page</li>
            <li>Qualitative feedback from surveys</li>
          </ul>
        </td>
      </tr>
      <tr>
        <td>Evaluate ease of finding book recommendations.</td>
        <td>
          <ul>
            <li>Users quickly found desired books</li>
            <li>Users showed confusion or difficulty</li>
          </ul>
        </td>
        <td>
          <ul>
            <li>Average time spent finding a relevant book</li>
            <li>Average number of books consulted</li>
            <li>Cursor movement distance</li>
          </ul>
        </td>
      </tr>
      <tr>
        <td>Measure user satisfaction and suggest improvements.</td>
        <td>
          <ul>
            <li>User feedback about navigation ease and clarity of design</li>
            <li>Overall experience and recommendations</li>
          </ul>
        </td>
        <td>
          <ul>
            <li>User satisfaction ratings (Likert scale)</li>
            <li>Qualitative feedback from open-ended responses</li>
          </ul>
        </td>
      </tr>
    </tbody>
  </table>
`


  },
  {
    title: 'User Testing Protocol',
    body: `    
    <p>
      We conducted structured usability testing with 16 participants who were all first-time users and collected data through click tracking, cursor trajectory, task completion time, and post-task surveys.
    </p>
      <table class="tasks-goals-table">
    <thead>
      <tr>
        <th>Tasks</th>
        <th></th>
        <th>Goals</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td><strong>Task 1</strong></td>
        <td>
          <ul>
            <li>Create an account</li>
            <li>Find a book you’d like to read</li>
          </ul>
        </td>
        <td>
          <ul>
            <li>Understand how first-time users navigate the platform</li>
          </ul>
        </td>
      </tr>

      <tr>
        <td><strong>Task 2</strong></td>
        <td>
          <ul>
            <li>Complete mini-challenges using different Goodreads features to find books</li>
          </ul>
        </td>
        <td>
          <ul>
            <li>Evaluate usability across key site sections</li>
            <li>Observe how users explore and understand site functions</li>
          </ul>
        </td>
      </tr>

      <tr>
        <td><strong>Task 3</strong></td>
        <td>
          <ul>
            <li>Find a book recommendation for a friend’s birthday</li>
          </ul>
        </td>
        <td>
          <ul>
            <li>Identify which discovery paths users prefer</li>
            <li>Assess effectiveness of social-based recommendations</li>
          </ul>
        </td>
      </tr>
    </tbody>
  </table>
`
  },
  {
    title: 'Data Analysis',
    body: `  
    <p>
      Using Python (<code>pandas</code>, <code>numpy</code>, <code>matplotlib</code>, <code>seaborn</code>), we analyzed cursor movement data and generated heatmaps to visualize user interaction.
      We also performed thematic analysis on qualitative feedback to identify key usability issues.
    </p>
    <br>
    <h3>Task 1</h3>
    <div class="observations">
      <div class="observation">
        <p><strong>Observation 1:</strong> Users who spent more time and clicked around more frequently usually gave lower ratings.
        Spending a lot of time and making many clicks might mean users were confused or had difficulty finding what they wanted.</p>
      </div>

      <div class="observation">
        <p><strong>Observation 2:</strong> Users mainly interacted with the “Browse” and “My Books” sections on the navigation bar.
        “My Books” section typically contains no relevant content for new users -> could leading to confusion/uncertainty.</p>
      </div>
    </div>
    <img src="/images/graph2.png" class="goodreads-image1" />

    <br>
    <h3>Task 2</h3> 

    <div class="observations">
      <div class="observation">
        <p><strong>Observation 3:</strong> "Similar Books" section was the most engaging. 
        Users spent an average of 1.9 minutes in this section and consulted 2.2 books.</p>
      </div>
      <div class="observation">
        <p><strong>Observation 4:</strong> "Community" section was users’ main pain point.
        With 3.1 minutes spent on average, they consulted the fewest books (0.7) -> indicating struggle rather than productive engagement.</p>
      </div>
    </div>
    <img src="/images/graph1.png" class="goodreads-image1" />


    <br>
    <h3>Task 3</h3> 
    <div class="observations">
      <div class="observation">
        <p><strong>Observation 5:</strong> Users relied heavily on Book Pages and Friend Profiles, rather than spending time in core sections of GoodReads. 
        This suggest that while personal data helps with finding gifts, users still need better comparison tools and a more direct, goal-oriented recommendation flow.
      </p>
      </div>

    </div>
    <img src="/images/graph4.png" class="goodreads-image1" />
    `
  },
  {
    title: 'Insights',
    body: `
      <p> Based on the user testing, we recommend the following actions to enhance the user experience on GoodReads:<p/>

  <section class="ux-recommendations">

  <div class="ux-insight">
    <h4>Observation 1 & 2 (Task 1)</h4>
    <p class="insight-title">→ Reduce user confusion through clearer navigation cues</p>
    <p>Simplify page hierarchy and navigation; highlight relevant sections like <em>Browse</em> instead of empty “My Books.”</p>
  </div>

  <div class="ux-insight">
    <h4>Observation 3 (Task 2)</h4>
    <p class="insight-title">→ Improve discoverability and relevance of recommendations</p>
    <p>Enhance “Similar Books” with comprehensive filters; add a <em>Compare Books</em> option for easier evaluation.</p>
  </div>

  <div class="ux-insight">
    <h4>Observation 4 (Task 2)</h4>
    <p class="insight-title">→ Redesign the Community section for clarity and engagement</p>
    <p>Streamline layout, modernize visuals, and highlight active discussions and personalized threads.</p>
  </div>

  <div class="ux-insight">
    <h4>Observation 5 (Task 3)</h4>
    <p class="insight-title">→ Support goal-oriented gifting experiences</p>
    <p>Add a “Gifting Books” section and quick gifting features within Friend Profiles.</p>
  </div>

  <div class="ux-insight">
    <h4>Summary of all tasks</h4>
    <p class="insight-title">→ Personalize continuously based on user behavior</p>
    <p>Use browsing data and micro-feedback (“Not interested”, “Show more like this”) for dynamic recommendations.</p>
  </div>
</section>

`

    },
  {
    title: 'Takeaways',
    body: `
  <h2>My Contributions</h2>
  <ul>
    <li>Creating and brainstorming the <strong>user journey map</strong></li>
    <li>Designing and conducting the <strong>user testing protocol</strong></li>
    <li>Processing and analyzing the quantitative survey data; <strong>creating visualizations</strong> to support findings</li>
    <li>Drafting <strong>actionable UX recommendations</strong> based on user feedback and data</li>
  </ul>
  <h2>Lessons Learned</h2>
  <ul>
    <li>This experience strengthened my ability to approach design problems systematically from framing research questions to synthesizing quantitative and qualitative data.</li>
    <li>I learned which signals and metrics to measure to achieve my goals in understanding users’ pain points, and how to use data insights to create actionable UX recommendations.</li>
    <li>I strengthened my skills in UX research, data analysis, and the application of human-centered design principles to real-world 
     platforms.</li>
  </ul>
`
  },
],

    description: ``,
    tags: ['User Experience', 'User Research', 'Quantitative Data'],
    links: [
     // { name: 'Read Full Report', url: 'https://quantux.telecom-paris.fr/2025/03/07/evaluating-the-usability-of-goodreads/' },
    ],
  },
  'borderless-whiteboard': {
    title: 'Borderless',
    subtitle: 'A unified design collaboration platform',
    //images: ['/images/borderless3.png','/images/borderless.png','/images/borderless1.png','/images/borderless2.png'],
    images: [],
    summary: 'A collaborative whiteboard design integrating expert feedback, accessibility, and version control.',
    info: {
    tasks: ['UX Research', 'UX Design', 'Prototype'],
    tools: ['Figma', 'Google Forms'],
    team: ['3 Members'],
    role: ['User Interview', 'Personas', 'Design Direction', 'Wireframe'],
    timeline: 'Nov 2024 – Dec 2024'
    },
    sections: [
      {
        title: 'Background',
        body: `
        
        <div class="content-container">
          <div class="text-section">
            <p><strong>Borderless</strong> is a collaborative whiteboard tool designed for creative teams working remotely. 
            It aims to <strong>unify the needs of various creative fields</strong>, tackle the issues of collaboration and address existing pain points of current whiteboard tools.</p>
            <p>We propose <strong>3 main features:</strong> Layered workspaces, enhanced collaborative tools and version control support.</p>
          </div>
          <video 
            controls 
            autoplay 
            muted 
            loop 
            playsinline 
            class="video-section2">
            <source src="/images/border.mp4" type="video/mp4">
            Your browser does not support the video tag.
          </video>
        </div>

      <article>
        <h3>Problem</h3>
        <p>Remote creative teams face <strong>collaboration challenges</strong> caused by disorganized workflows, 
        fragmented communication, and tools that lack version control, accessibility, and flexibility across different creative disciplines.
        </p>
      </article>
  `
      },
      {
        title: 'Process',
        process: [
          { step: '01', phase: 'Understand', items: ['Competitive Analysis', 'User Survey'] },
          { step: '02', phase: 'Identify', items: ['Affinity Diagram', 'Design Direction'] },
          { step: '03', phase: 'Design', items: ['Personas', 'User Scenario'] },
          { step: '04', phase: 'Implement', items: ['Prototyping'] },
        ],
      },
      {
        title: 'Competitive Analysis',
        body: `<p>We analyzed existing whiteboard design tools to understand the benchmark:</p>
        <ul>
          <li><strong>Jamboard:</strong> Easy but lacks advanced creative tools.</li>
          <li><strong>FigJam:</strong>  Collaborative and polished but heavily UX-focused.</li>
          <li><strong>LucidSpark:</strong>  Strong in diagramming, limited for artistic workflows.</li>
          <li><strong>Miro:</strong>  Feature-rich but overwhelming for non-designers and not optimized for multimedia-heavy use.</li>
        </ul>`
      },
      {
        title: 'User Survey',
        body: `<div class="survey-section">
  <div class="survey-text">
    <p>We sent surveys to <strong>5 professionals</strong> in the design and animation sector.</p>
    <p>As we wanted to create a unified platform for all creatives in the industry,
    we wanted to have a variety of people with different backgrounds, so we had <strong>1 graphic designer, 3 UX designers, and 1 motion designer</strong>. 
    We knew them personally and trusted their experience in their fields. Due to time limitation, we couldn't reach out to more people.</p>
    
    <p><strong>Questions involved →</strong> which collaborative tools they are using, 
    their impact on their work, as well as which features stand out to them in these tools. The most important questions tackled 
    the <strong>limitations of the current design tools</strong> and asked for suggestions of improvement.</p>
    <a href="https://docs.google.com/spreadsheets/d/1x69xa6dPA0XqchsEPvcIKDQTN2vg_dAlqAJVSzbsaII/edit?usp=sharing" target="_blank" rel="noreferrer">
        <button class="visit-button">See Interview Responses</button>
      </a>
  </div>
  

  <div class="quote-cards">
    <h3>Valuable Quotes</h3>
    <div class="quote-card">
      <p>“A valuable feature would be a version control system similar to Git, allowing teams to track changes, merge design updates seamlessly, and revert to previous iterations when needed.”</p>
    </div>
    <div class="quote-card">
      <p>“I would love to see real-time collaborative editing in tools like Procreate or Adobe Animate, allowing multiple artists to work on the same project simultaneously, similar to how Figma works for design.”</p>
    </div>
  </div>
</div>

     `
      },
      {
        title: 'Affinity Diagram',
        body: ` <p>Based on the user interviews, we identified common pain points and grouped them into 4 main categories.</p>
        <div class="affinity-grid">
          <div class="affinity-card">
            <h4>Group 1: <span>Collaboration & Workflow Management</span></h4>
            <ul>
              <li>Other people’s activity can get mixed up.</li>
              <li>Too many comments get overwhelming.</li>
              <li>Finding things could be easier.</li>
              <li>Real-time editing tools missing in animation apps.</li>
              <li>Paper-to-digital transition could be smoother.</li>
            </ul>
          </div>

          <div class="affinity-card">
            <h4>Group 2: <span>Performance & Reliability</span></h4>
            <ul>
              <li>Performance issues with large-scale projects.</li>
              <li>Lag with large files.</li>
              <li>Limited offline functionality.</li>
            </ul>
          </div>

          <div class="affinity-card">
            <h4>Group 3: <span>Version Control & Resource Management</span></h4>
            <ul>
              <li>Need for version control system.</li>
              <li>Need for integrated library for shared assets.</li>
            </ul>
          </div>

          <div class="affinity-card">
            <h4>Group 4: <span>Intelligent & Creative Assistance</span></h4>
            <ul>
              <li>Enhanced real-time design suggestions.</li>
              <li>Auto-generate in-between frames.</li>
              <li>Better animation tools in Figma.</li>
            </ul>
          </div>
        </div>
        `

      },
      {
        title: 'Design Direction',
        body: `
        <p>
        To address the recurring pain points, we came up with three key features.
        Since we had time constraints for the design, we decided to focus on the most impactful features from UX perspective.
        Hence, we didn't address performance issues and need for creative assistance in our prototype.</p>
        <table class="gsm-table-borderless">
          <thead>
            <tr>
              <th></th>
              <th>Layered Workspaces</th>
              <th>Collaborative Tools</th>
              <th>Version Control</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>Pain point</strong></td>
              <td>Workspace becomes cluttered and hard to navigate.</td>
              <td>Limited ways to co-create or share ideas in real time.</td>
              <td>Hard to continue work or sync progress when offline.</td>
            </tr>
            <tr>
              <td><strong>Function</strong></td>
              <td>Allows users to organize sketches and feedback across separate layers.</td>
              <td>Enables real-time co-editing with voice, text, and sticky notes.</td>
              <td>Supports version control and auto-saves changes locally and syncs automatically once reconnected.</td>
            </tr>
            <tr>
              <td><strong>Value</strong></td>
              <td>Clearer, less crowded structure and smoother navigation across tasks.</td>
              <td>More interactive teamwork and quicker decision-making.</td>
              <td>Reliable workflow continuity and prevention of data loss. Easy to revert changes.</td>
            </tr>
          </tbody>
        </table>
        `
      },
      {
  title: 'Personas',
  body: `
  <p>To guide our design decisions and ensure Borderless supports different types of collaborators, we created three personas representing varying levels of experience and accessibility needs.</p>

<div class="persona">

  <!-- ANNA -->
  <div class="persona-card">
    <img class="persona-avatar" src="/images/anna.png"/>
    <div class="persona-content">
      <h3 class="persona-title">
        Anna <span class="persona-tag">- Expert User</span>
      </h3>
      <section class="persona-section">
        <p><strong>Role:</strong> Lead Concept Developer & Storyboard Artist</p>
        <p><strong>Behavior:</strong> Facilitates sessions, onboards teammates, navigates past work to set context.</p>
        <p><strong>Goal:</strong> Kick off meetings quickly, give newcomers context, coordinate real-time collaboration.</p>
        <p><strong>Usage Scenario:</strong> 
          Starts the first design meeting in Borderless, invites Bob, swipes through the design timeline to onboard him, and shares a project link with Carla. 
          Sets up sections (“Characters”, “Scenes”, “Plot Ideas”), assigns areas, and leaves voice memos for feedback.
        </p>
      </section>
    </div>
  </div>

  <!-- BOB (formerly Mary) -->
  <div class="persona-card">
    <img class="persona-avatar" src="/images/bob.png"/>
    <div class="persona-content">
      <h3 class="persona-title">
        Bob <span class="persona-tag">- New User</span>
      </h3>
      <section class="persona-section">
        <p><strong>Role:</strong> Design Intern</p>
        <p><strong>Behavior:</strong> First-time user, learns by doing; contributes mood boards, sticky notes, and quick sketches.</p>
        <p><strong>Goal:</strong> Get oriented fast, understand expectations, and contribute confidently.</p>
        <p><strong>Usage Scenario:</strong> 
          Joins via invite link, completes a short onboarding tutorial, creates a mood board, adds sticky notes and emojis, and uses a scene template to sketch ideas. 
          Redirects Anna and Carla to his section for feedback.
        </p>
      </section>
    </div>
  </div>

  <!-- CARLA (formerly Carl) -->
  <div class="persona-card">
    <img class="persona-avatar" src="/images/carla.png"/>
    <div class="persona-content">
      <h3 class="persona-title">
        Carla <span class="persona-tag">- Extreme User (Deaf)</span>
      </h3>
      <section class="persona-section">
        <p><strong>Role:</strong> Senior Character Artist</p>
        <p><strong>Behavior:</strong> Collaborates visually; relies on transcripts and captions; contributes via layers and annotated references.</p>
        <p><strong>Goal:</strong> Follow discussions in real time and provide precise visual feedback.</p>
        <p><strong>Usage Scenario:</strong> 
          Enters via project link, enables Accessibility Mode and Transcript Mode, views Anna’s voice memos with transcripts, adds clothing-style layers, uploads references, and leaves captioned notes.
        </p>
      </section>
    </div>
  </div>

</div>

  `
},
      {
        title: 'User Scenario',
        body: `Based on these 3 personas, we created a detailed user scenario where they're using Borderless. (A quick highlight of each persona's contribution is given in their respective information card.) The summary of the scenario flow is as follows:
        <ul>
          <li>The session begins with onboarding through setting up the design space and accessibility options.</li>
          <li>Team members divide tasks across different layers, focusing on “Characters,” “Scenes,” and “Plot Ideas.”</li>
          <li>Collaboration tools like freehand drawing, virtual post-its, and voice memos facilitate brainstorming and idea sharing.</li>
          <li>An interruption in internet connection occurs as there's a power outage, but Borderless saves the progress offline.</li>
          <li>The team uses visual pointers, video calls, the redirect tool, and live transcripts for accessibility.</li>
          <li>The session concludes with saving the collaborative draft with version control, assigning action points, and scheduling the next meeting.</li>
        </ul>
        `
      },
      {
        title: 'Prototyping',
        body: `<p>We designed wireframes to lay the foundation of the layout and the user experience on paper. Then we translated them into low-fidelity
        prototypes and created a video prototype to showcase the design features we added to Borderless.</p>

        <h3>Feature 1: Layered Workspaces</h3> 
        <p>These tools allow multiple users to provide input simultaneously on the same canvas. They enable real-time idea sharing and feedback, allowing team members to layer their contributions without interfering with others' work. The users can toggle visibility or directly navigate to someone else's workspace.</p>
        <img src="/images/layeredworkspace.png" class="goodreads-image1" />
        <h3>Feature 2: Collaborative Tools</h3> 
        <p>Real-time voice and video calls are embedded directly into the platform, enabling live discussions and fostering a sense of collaboration. They enhance communication by allowing team members to explain ideas verbally, clarify misunderstandings, and stay engaged.</p>
        <img src="/images/tools-ss.png" class="goodreads-image1" />
        <h3>Feature 3: Version Control</h3> 
        <p>A feature inspired by version control systems like Git, allows users to track changes, merge updates, and revert to previous iterations. This prevents loss of work, ensures clarity during design iterations, and enables seamless collaboration on evolving projects.</p>
        <img src="/images/version-control.png" class="goodreads-image1" />
        `
      },
      {
        title: 'Takeaways',
        body: `
        <h2>My Contributions</h2>
        <p>In this project, I was responsible for preparing the user survey and analyzing the answers to create the affinity diagram. As a team,
        we brainstormed ideas on how to tackle the user pain points found in the survey. We came up with
        personas and user scenarios, and created first wireframes with paper together. I helped with the layout and interaction methods
        for the prototype, and its details were completed by my teammates.</p>
        
        <h2>Lessons Learned</h2>
        <div class="text-section">
    <p><em>Borderless</em> taught me valuable lessons about collaboration, inclusivity, and the iterative nature of design:</p>

    <ul>
      <li>
        <strong>Understanding users deeply →</strong> Defining <em>experienced</em>, <em>new</em>, and <em>extreme</em> users early in the process 
        helped uncover needs that would otherwise stay hidden —> especially accessibility challenges and onboarding gaps.
      </li>

      <li>
        <strong>Designing with empathy →</strong> Creating personas like <em>Carla</em>, our deaf user, 
        taught me how small design decisions can make or break inclusivity in collaborative tools.
      </li>

      <li>
        <strong>Collaboration & teamwork →</strong> Working closely with two teammates through every phase (from surveys to prototyping) 
        improved my ability to brainstorm, give constructive feedback, and merge ideas into a cohesive design.
      </li>

      <li>
        <strong>Iterating systematically →</strong> The process of analyzing survey data, grouping insights, and transforming them into 
        actionable features strengthened my confidence in making research and design decisions.
      </li>

      <li>
        <strong>Future direction →</strong> If extended, I’d like to test the <em>layered workspace</em> feature with users and develop a 
        <strong>high-fidelity prototype</strong> to refine the interaction flow and accessibility mode.
      </li>
    </ul>
  </div>
        `
      }
    ],
    description: ``,
    tags: ['User Experience'],
    links: [
      //{ name: 'Full Design Report', url: 'https://drive.google.com/file/d/1n47yX4QeSf5n3KgixUH0QQJgkGh40754/view?usp=sharing' },
    ],
  },
  puzzlemove: {
    title: 'Level Designs',
    subtitle: '6 Years of Experience with Angry Birds',
    images: [],
    summary: [],
    tags: ['Level Design', 'Player Psychology', 'Gameplay Balancing'],
    links: [],
    description: `<section class="abdb-section">
    <br>
    <p>I have +6 years of professional experience as a game level designer and tester.
  I have designed +2500 games and tested +5000 levels of Angry Birds Dream Blast, Sugar Blast, 
  Angry Birds Match-3, Chef Blast, Chrome Valley Customs and Merge Gardens.</p>


  <div class="intro-row">

    <div class="text">
    <h2>
      <a href="https://www.angrybirds.com/games/angry-birds-dream-blast/" target="_blank" rel="noopener noreferrer">
        Angry Birds Dream Blast ↗
      </a>
    </h2>
      <p>
        <em>Angry Birds Dream Blast</em> is a casual mobile puzzle game from Rovio Entertainment, part of the world-famous 
        <em>Angry Birds</em> franchise.
      </p>
      <p>Unlike the traditional slingshot games, Dream Blast focuses on 
        <strong>bubble-matching mechanics</strong>, where players pop and combine colorful bubbles to complete goals. 
        It’s known for its soft, physics-based animations, charming visuals, and satisfying chain reactions that make 
        every level feel playful and dynamic.
      </p>
    <p>
      <em>Angry Birds Dream Blast</em> is the game I've worked on the most, for over six years (since 2019), designing and testing hundreds of levels. 
      My focus was on balancing <strong>fun, challenge, and flow</strong>.
    </p>
  </div>

    <div class="video-pair">
      <video autoplay muted loop playsinline>
        <source src="/images/abdb1.mp4" type="video/mp4" />
      </video>
      <video autoplay muted loop playsinline>
        <source src="/images/abdb2.mp4" type="video/mp4" />
      </video>
    </div>
  </div>

  <div class="intro-row">

    <div class="video-pair">
      <video autoplay muted loop playsinline>
        <source src="/images/abdb3.mp4" type="video/mp4" />
      </video>
      <video autoplay muted loop playsinline>
        <source src="/images/abdb4.mp4" type="video/mp4" />
      </video>
    </div>
    <div class="text">
     
    <p>The game has various mechanics that are updated continuously, which helped me develop a strong sense of adaptability and creative problem-solving. Through this long-term experience, I’ve gained skills in:</p>

<ul class="skills-list">
  <li><strong>Adaptiveness →</strong> adjusting to frequent design and mechanic updates while keeping levels consistent and engaging.</li>
  <li><strong>Understanding player psychology →</strong> predicting player behavior, designing for satisfaction loops, and reducing frustration points.</li>
  <li><strong>Difficulty balancing →</strong> creating fair challenges with smooth progression curves and pacing across hundreds of levels.</li>
  <li><strong>Flow design →</strong> ensuring a natural rhythm between calm and challenging moments to maintain long-term player engagement.</li>
  <li><strong>Playtesting & iteration through collaboration →</strong> working closely with other designers to iterate based on feedback, and test other levels by giving feedback.</li>
</ul>

  </div>

  </div>
    <div class="more-examples">
      <h3>More Examples ↓</h3>
      <p>
        The remaining section includes image examples of other match-3 levels I have designed over the past years.<br> 
        Click to view each level in more detail.
      </p>
    </div>

    <div class="levels-gallery">
      <img src="/images/level1.png" alt="Level 1" />
      <img src="/images/level2.png" alt="Level 2" />
      <img src="/images/level3.png" alt="Level 3" />
      <img src="/images/level6.png" alt="Level 6" />
      <img src="/images/level4.png" alt="Level 4" />
      <img src="/images/level5.png" alt="Level 5" />
    </div>

  <div id="imageModal" class="image-modal">
    <span class="close">&times;</span>
    <img class="modal-content" id="modalImage" />
  </div>

</section>
`,
  },
  match3: {
    title: 'Extensive Analysis of Four Popular Match-3 Games',
    images: ['/images/match3.png'],
    summary: `My analysis of four match-3 games (Royal Match, Toon Blast, Candy Crush, Gardenscapes) based on game mechanics, level design, level difficulty, graphics, animation, particles & special effects, and user interface.`,
    tags: ['Game Design', 'Level Design'],
    links: [
      { name: 'Full Case Study', url: 'https://docs.google.com/spreadsheets/d/10G2jgNwXrPaCte0bd49-9XR0doQKxXzTZl_oW4qBMxw/edit?usp=sharing' },
    ],
    description: `
    <p>I analyzed four popular match-3 games and wrote a <strong>+10,000 word case study</strong> by breaking down their design across core categories: 
    <strong>game mechanics, boosters, goals, level design, difficulty progression, graphics, animation, particle effects, and user interface</strong>.
    </p>

    <p>I played the first 60 levels of each game, recorded my tests and notes for each level, analyzing them as comprehensive as possible.
    I evaluated how each game’s matching systems and boosters shaped player strategies, assessed level progression and pacing to understand balancing, 
    and reviewed visual direction through themes, color palettes, and readability of game elements. 

    <p>I studied UI and UX design choices with a focus on navigation, hierarchy, and accessibility. By comparing these aspects across games, I gained a 
    comprehensive understanding of different design approaches and their impact on player experience.
    </p>
    `
  },
  echonos: {
    title: 'Echonos: Game Design with CBT Methods for Social Anxiety',
    images: ['/images/echonos.png'],
    summary: 'A visual novel game design for adults with Social Anxiety Disorder, integrating cognitive behavioral therapy.',
    description: `
<p><strong>Echonos</strong> is a narrative-driven serious game designed to help adults with <em>Social Anxiety Disorder (SAD)</em> identify and restructure cognitive distortions using principles from <strong>Cognitive Behavioral Therapy (CBT)</strong>. Set in the mystical village of Bridgeville, where unresolved thoughts manifest as villagers, players take on the role of a guide helping these characters navigate their internal struggles.</p>

<p>This project emerged from personal and academic motivation, as well as a gap in existing therapeutic games, most of which are either designed for children or focus only on isolated CBT concepts.</p>

<p>We followed a comprehensive design process:</p>
<ul>
  <li>📚 <strong>Literature review:</strong> We explored works on serious games, CBT therapy, player psychology, and therapeutic game frameworks.</li>
  <li>🧑‍⚕️ <strong>Expert-informed development:</strong> The game design was shaped by findings from prior CBT-based interventions and therapist best practices.</li>
  <li>🎭 <strong>Scenario building:</strong> Each interaction is modeled on a specific cognitive distortion (e.g., catastrophizing, labeling, overgeneralization), with tailored NPC stories and dialogue flows.</li>
  <li>🎮 <strong>Prototyping & storyboarding:</strong> Using Figma, we created interactive wireframes and tested how narrative, UI, and mechanics align with therapeutic goals.</li>
</ul>

<p>The gameplay unfolds through a visual novel format with interactive choices. Players explore a map of Bridgeville and visit NPCs where each represents a unique distortion. Through dialogue, they highlight distorted thoughts, classify them, and select restructuring options. The game provides immediate, educational feedback for both correct and incorrect choices, ensuring players understand the rationale behind each CBT concept.</p>

<p>We propose an evaluation plan where therapists assess participants with SAD using pre- and post-game questionnaires. The aim is to measure improvements in identifying distortions, emotional regulation, and CBT technique application to help validate the game's therapeutic potential.</p>
`,
    tags: ['Game Design'],
    links: [
      {
        name: 'Full Project Report',
        url: 'https://drive.google.com/file/d/1CVmKLZB8k2vroIGE5LEznjeIbIS9NyZM/view?usp=sharing',
      },
      {
        name: 'Video Prototype',
        url: 'https://drive.google.com/file/d/1-OQfY0xUEjzTiznpge_v3DLJxOA67QQy/view?usp=sharing',
      },
    ],
  },
  consciously: {
    title: 'Consciously',
    subtitle: 'A browser extension design to prevent impulsive shopping',
    images: [],
    summary: 'A browser extension design to prevent impulsive shopping and develop mindful shopping skills.',
    info: {
    tasks: ['UX Design', 'Prototype'],
    tools: ['Figma'],
    team: ['Individual Project'],
    role: ['Ideation', 'Figma Prototyping'],
    timeline: 'Feb 2025 – April 2025'
    },
    sections: [
      {
        title: 'Context',
        body: `
        <div class="content-container">
          <div class="text-section">
            <p><em>Consciously</em> is a browser extension designed to <strong>interfere with impulsive online shopping</strong> through
            emotional check-in at the point of purchase. The tool 
            encourages mindful consumption and counters dark UX patterns like fake urgency and manipulative pricing.</p>
            
            <p>As someone who often shops impulsively during sales, I wanted to create a tool that helps people like me make more mindful purchase decisions.</p>

            <article>
              <h3>Problem</h3>
              <p>
                Many users buy impulsively when they’re bored, stressed, or seeking quick comfort. 
                <strong>Dark UX patterns</strong> like countdown timers or “only 2 left” messages could <strong>lead to pressure to buy, regret and overspending</strong>.
              </p>
            </article>

            <article>
              <h3>Key Challenges</h3>
              <ul>
                <li>Encouraging self-reflection without interrupting the flow too much</li>
                <li>Designing prompts that feel supportive, not judgmental</li>
                <li>Balancing emotional awareness with usability and speed</li>
                <li>Creating long-term engagement and consistent usage habits</li>
              </ul>
            </article>

            <a href="#prototypes">
              <button class="visit-button"><strong>Jump to prototypes ⬇</strong></button>
            </a>
        </div>

        <video 
          controls 
          autoplay 
          muted 
          loop 
          playsinline 
          class="video-section">
          <source src="/images/demo1.mp4" type="video/mp4">
          Your browser does not support the video tag.
        </video>
      </div>
      `
      },
      {
        title: 'Process',
        process: [
          { step: '01', phase: 'Empathize', items: ['Desk research'] },
          { step: '02', phase: 'Define', items: ['Personas', 'User Scenario'] },
          { step: '03', phase: 'Ideate', items: ['Brainstorming', 'Design Space'] },
          { step: '04', phase: 'Prototype', items: ['Figma Prototyping', 'Iterations'] },
          { step: '05', phase: 'Test', items: ['User Testing'] },
        ],
      },
      {
        title: 'Desk Research',
        body: `<div class="research-cards">

  <div class="research-card">
    <p>
      Shopping is often an emotional act. 
      Research by Harvard professor Gerald Zaltman shows that 
      <a class="source" href="https://www.inc.com/logan-chierotti/harvard-professor-says-95-of-purchasing-decisions-are-subconscious.html">
        <strong>🔎 95% of purchasing decisions happen subconsciously</strong>
      </a>.
    </p>
  </div>

  <div class="research-card">
    <p>
      A good example is <strong>Blue Monday</strong>, the “saddest day of the year.” 
      Low mood after the holidays makes people more vulnerable to emotional spending, 
      and brands actively tap into this with “mood-boosting” deals.
    </p>
  </div>

  <div class="research-card">
    <p>
      And it works! A 2023 report shows that 
      <a class="source" href="https://significa.co/blog/how-emotions-shape-our-shopping-habits">
        <strong>🔎 sales increased by 18% on Blue Monday</strong>
      </a>proving how strongly emotions shape consumer behavior.
    </p>
  </div>

</div>

`

      },
      { 
        title: 'Personas',
        body: `
        To better understand the user, I created 2 personas to represent different emotional shopping behaviors. Each persona represents distinct problems they face when they are shopping, highlighting different behaviors and frustrations. 
        I've included different usage scenarios for each of them, so see how my system could effectively help them solve their issues.

        <div class="persona">
          <div class="persona-card">
            <img class="persona-avatar" src="/images/carla.png"/>
            <div class="persona-content">
              <h3 class="persona-title">
                Emma <span class="persona-tag">- Emotional Spender</span>
              </h3>
              <section class="persona-section">
                <p><strong>Age:</strong> 23 / <strong>Occupation:</strong> Student</p>
                <p><strong>Behavior:</strong> Scrolls shopping apps late at night to escape stress or loneliness. She enjoys the dopamine rush of buying and shares new purchases on social media for validation.</p>
                <p><strong>Goal:</strong> Gain control over emotional spending and reduce unnecessary purchases.</p>
                <p><strong>Frustration:</strong> Feels regret and shame when realizing her purchases were for emotional comfort, not real need.</p>
                <p><strong>Usage Scenario:</strong> 
                Feeling stressed after a long study day, Emma opens a shopping app “just to browse.” She adds a few items to her cart for a quick mood boost. Before she checks out, Consciously prompts her to identify her current emotion. She selects "stressed" and realizes she’s buying to cope, not out of need and closes the tab instead.
                </p>
                </section>
            </div>
          </div>

          <div class="persona-card">
            <img class="persona-avatar" src="/images/anna.png"/>
            <div class="persona-content">
              <h3 class="persona-title">
                Mary <span class="persona-tag">- Caring Mom</span>
              </h3>
              <section class="persona-section">
                <p><strong>Age:</strong> 34 / <strong>Occupation:</strong> Doctor, Parent of Two</p>
                <p><strong>Behavior:</strong> Buys clothes, toys, and home items for her two kids, often overspending during discounts as she sees them as chances to provide better for her family.</p>
                <p><strong>Goal:</strong> Shop more intentionally while still enjoying buying for her family.</p>
                <p><strong>Frustration:</strong> Feels overwhelmed by marketing that exploits parental guilt and overestimates what her kids actually need. Ends up with unused items and feels guilty about waste.</p>
                <p><strong>Usage Scenario:</strong> 
                During a 24-hour flash sale, Mary sees a “Buy 2, Get 1 Free” deal on children’s pyjamas and rushes to add several to her cart. Consciously interrupts the checkout, asking how she feels. She selects “fomo” and realizes she already bought pyjamas last month, she removes most of the items and completes the purchase calmly.
                </p>
                </section>
            </div>
          </div>
        </div>
        `
      },
      {
        title: 'Brainstorming',
        body: `
        <p>My process began by exploring how emotional awareness could interrupt impulsive shopping behavior.
        I generated multiple ideas focused on reflection, delay, and self-awareness before purchase:</p>
        <section class="brainstorm">
        <ul class="ideas">
          <li>
            <h3>Emotion Check-In Prompt</h3>
            <p>Ask users to select their current emotion and describe why they’re shopping before checkout.</p>
          </li>
          <li>
            <h3>Spending Reflection Journal</h3>
            <p>A digital log that records purchases, emotions, and follow-up reflections on satisfaction or regret.</p>
          </li>
          <li>
            <h3>Work-Hour Converter</h3>
            <p>Show users how many work hours an item costs, linking consumption with personal effort.</p>
          </li>
          <li>
            <h3>Impulse Timer</h3>
            <p>Introduce a short cooldown period (e.g., 10 minutes) before completing a purchase to reduce emotional reactivity.</p>
          </li>
          <li>
            <h3>Mindful Reminders</h3>
            <p>Send periodic notifications encouraging users to review past purchases and emotional triggers.</p>
          </li>
          <li>
            <h3>Regret Logging</h3>
            <p>Allow users to revisit previous purchases and record their level of satisfaction or regret, reinforcing long-term awareness of buying habits.</p>
          </li>
        </ul>
      </section>
        `
      },
      {
        title: 'Design Space',
        body: `<p>
          To objectively evaluate my brainstormed ideas and identify the core features that best aligned with my main goal,
          I created a Design Space. This framework allowed me to see all potential features through five critical lenses:
          <span class="highlight">
            Immediacy of Reflection, Emotional Depth, Disruption Level, Data Insightfulness and Integration with Shopping Flow
          </span>.
          By mapping where each idea stood on these dimensions, I could clearly see their strengths and weaknesses.
        </p>
        <img src="/images/radar-chart.png" class="goodreads-image1" />
        <h3>Design Space Analysis</h3>
        <p>My analysis results showed that the <strong>Emotion Check-In Prompt</strong> best embodied my main goal, introducing emotional awareness at the exact moment of purchase.
        Among all ideas, this feature offered the strongest immediacy and integration with the shopping flow, allowing users to pause and reflect before completing a transaction.
        </p>
        `
      },
{ 
        title: 'Prototype',
        body: `
        <div id="prototypes">
        <h2>Iteration 1: Mobile App</h2>

        <div class="content-container">
          <div class="text-section">

            <p>Initially, my brainstormed ideas felt too small on their own, and I wanted to combine them all in one platform: <strong>a budget tracking and mindful spending mobile app</strong>. 
            I thought that this would increase the value I'll be providing to users. Hence, my first concept was a multi-functional mobile app with features such as: </p>
            <ul>
              <li>Emotional check-ins</li>
              <li>Displaying the cost of items in work-hour equivalents</li>
              <li>Tracking monthly spending and providing analytics</li>
              <li>A wish list and purchase history</li>
              <li>A space for regret logging to reflect on past purchases</li>
            </ul>

            <p>
              I was inspired by an existing app called <a className="source" href="https://howwefeel.org/">How We Feel</a>, which helps
              users track their emotional states over time. I decided to add a similar
              functionality of the app in the context of shopping to my design and added a new screen that
              prompted users to reflect on how they felt before making a purchase.
            </p>

            <p>
            <strong>However...</strong> As I was prototyping, my inital idea began to feel like a collection of loosely connected features trying to
            exist together. With this realization, <strong>I started a new Figma prototype. ↓</strong></p>
          </div>

          <div  class="video-section-title">
            <h3 class="media-title">Wish list</h3>
            <video  controls  autoplay  muted loop  playsinline class="just-video">
              <source src="/images/consciously-wish.mp4" type="video/mp4" >
              Your browser does not support the video tag.
            </video> 
          </div>
        </div>
        <div class="content-container">
          <div  class="video-section-title">
            <h3 class="media-title">Purchase Logs</h3>
            <video  controls  autoplay  muted loop  playsinline class="just-video">
              <source src="/images/consciously-logs.mp4" type="video/mp4"  >
              Your browser does not support the video tag.
            </video> 
          </div>
          <div class="text-section">
            <h3 class="media-title">App Overview</h3>
             <img src="/images/consciously.png" class="goodreads-image1" />
          </div>
        </div>

    <div class="carousel-container">
        <div class="centered"></br>
        <h3><strong>Mini Iteration:</strong>
          I made my mock-ups appear more modern and polished.
        </h3>
        </div>
        <div class="carousel-wrapper">
            <div class="carousel-track" id="carouselTrack">
                <div class="iphone-mockup">
                    <div class="iphone-notch"></div>
                    <div class="iphone-screen">
                        <div class="screen-content">
                            <img src="/images/Homepage.png" alt="Project 1">
                        </div>
                    </div>
                </div>
                <div class="iphone-mockup">
                    <div class="iphone-notch"></div>
                    <div class="iphone-screen">
                        <div class="screen-content">
                            <img src="/images/Homepage-1.png" alt="Project 2">
                        </div>
                    </div>
                </div>
                <div class="iphone-mockup">
                    <div class="iphone-notch"></div>
                    <div class="iphone-screen">
                        <div class="screen-content">
                            <img src="/images/Wishlist.png" alt="Project 3">
                        </div>
                    </div>
                </div>
                <div class="iphone-mockup">
                    <div class="iphone-notch"></div>
                    <div class="iphone-screen">
                        <div class="screen-content">
                            <img src="/images/Wishlist-2.png" alt="Project 3">
                        </div>
                    </div>
                </div>
                <div class="iphone-mockup">
                    <div class="iphone-notch"></div>
                    <div class="iphone-screen">
                        <div class="screen-content">
                            <img src="/images/Wishlist-1.png" alt="Project 3">
                        </div>
                    </div>
                </div>
                <div class="iphone-mockup">
                    <div class="iphone-notch"></div>
                    <div class="iphone-screen">
                        <div class="screen-content">
                            <img src="/images/logs.png" alt="Project 3">
                        </div>
                    </div>
                </div>
                <div class="iphone-mockup">
                    <div class="iphone-notch"></div>
                    <div class="iphone-screen">
                        <div class="screen-content">
                            <img src="/images/logs-1.png" alt="Project 3">
                        </div>
                    </div>
                </div>
                <div class="iphone-mockup">
                    <div class="iphone-notch"></div>
                    <div class="iphone-screen">
                        <div class="screen-content">
                          
                            <img src="/images/Subscriptions.png" alt="Project 3">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <button class="nav-button prev" id="prevBtn" onclick="scroll(-1)"></button>
        <button class="nav-button next" id="nextBtn" onclick="scroll(1)"></button>

        <div class="progress-container">
            <div class="progress-bar" id="progressBar"></div>
        </div>
    </div>
<div class="iteration-section">

  <div class="iteration-row">

    <div class="iteration-text">
      <h2>Iteration 2: Browser Extension</h2>
      <p>With the realization that the emotional check-in feature had strong potential as a standalone feature,
      I started designing a <strong>browser extension that interrupts the real-time shopping process</strong>. This approach was more focused, effective, and aligned with the design space analysis.</p>

      <p>The key functionalities of this prototype include:</p>

      <ul>
        <li><strong>A shopping intervention</strong> triggered when users attempt to purchase something</li>
        <li>Prompts users to select an emotion from <strong>16 categories</strong>, explain their motivation, and choose a price range</li>
        <li>Generates insights based on emotions, spending patterns, time of day, and categories</li>
      </ul>

      <p>Here is a <strong>simple user flow video prototype:</strong></p>
    </div>

    <div class="iteration-image">
      <img src="/images/mockup-c.png" alt="Browser Extension Concept" />
    </div>

  </div>

  <video 
    controls 
    autoplay 
    muted 
    loop 
    playsinline 
    class="goodreads-image1">
    <source src="/images/demo.mp4" type="video/mp4">
    Your browser does not support the video tag.
  </video>

</div>


        <h2>Iteration 3: Added Features</h2>
        <p>
          After prototyping the main feature of emotional check-in, I expanded my prototype with three features:</p>

        <ul>
          <li>View past purchases and log</li>
          <li><strong>Reflection journal</strong> where the user can write how they are feeling about a possible purchase</li>
          <li><strong>Mindfulness notifications</strong> that remind the user to reflect on a purchase after a certain period</li>
        </ul>
        <p>
        The first and second features were added later because I did not have enough time to prototype them. The third feature
        was added after conducting a user testing and it was a recommended feature in one of the participant's feedback. Below,
        you can find the screenshots from the prototype for these features:
        </p>
      <img src="/images/ss.png" class="goodreads-image1" />
       
      </div>`
      },

      {
  title: 'User Testing',
  body: `
  <section class="user-testing">

    <h2>Overview</h2>
    <p>To evaluate my prototype, I ran informal tests with two participants who often make impulsive purchases on platforms like Zalando and Trendyol. 
    Since this was a personal project, the participants were among my friends.
    They explored a Figma prototype simulating a checkout on Backmarket and shared their feedback.</p>

    <div class="testing-grid">
      <div class="testing-card">
        <h4>Positive Insights 👍</h4>
        <ul>
          <li>The emotional check-in made users pause and reflect before buying.</li>
          <li>Helped them recognize hidden emotions like curiosity and fomo.</li>
          <li>Users liked the Insights page for tracking emotional patterns.</li>
        </ul>
      </div>

      <div class="testing-card">
        <h4>Challenges & Suggestions ⚠️</h4>
        <ul>
          <li>Pop-up could feel interruptive and unnecessary during quick purchases.</li>
          <li>Requested more emotional categories for check-in options.</li>
          <li>Suggested reminders for post-purchase reflection.</li>
        </ul>
      </div>
    </div>

    <h2>Outcome</h2>
    <p>
      Feedback validated the effectiveness of <em>Consciously</em> and inspired new features like reflection reminders.
    </p>

    <p>
    <strong>The next steps -></strong> Talk to a psychologist to clearly define the list of emotions based on science, since I picked the 16 emotions based on my personal experiences.
    Also, give users the option to activate or deactivate Consciously on selected shopping sites would make the experience feel less interruptive and more user-friendly.</p>

  </section>
  `
},
      { 
        title: 'Takeaways',
         body: `<div class="text-section">
  <p><em>Consciously</em> was my first individual design project, and it taught me several key lessons along the way:</p>

  <ul>
    <li>
      <strong>Learning to let go -></strong> I realized the importance of not getting too attached to a single idea or design. 
      I had to restart my Figma prototype and abandon a few “really cool” concepts that didn’t serve the project’s main goal.
    </li>

    <li>
      <strong>Iterating through feedback -></strong> Long discussions with my professors helped me practice receiving feedback and improving my designs. 
      I learned that each iteration added value, and that perfection isn’t the goal.
    </li>

    <li>
      <strong>Experiencing the full UX process -></strong> Working alone allowed me to explore every step of UX design. 
      It showed me both the value of teamwork and the benefit of understanding every aspect of the process, which is especially valuable for a junior designer.
    </li>

    <li>
      <strong>Personal connection -></strong> As someone who struggles with impulsive shopping during events like Black Friday, 
      this project was deeply personal. Identifying 16 emotions behind shopping behavior gave me insights that still influence how I shop today.
    </li>
  </ul>
</div>

          `
        },
    ],
    
    description: null,/* `

    <p>The project began as a mobile app concept, but after initial design critiques and reflection, I pivoted to a browser extension format to intervene directly during the act of shopping. The emotional check-in feature was inspired by the <em>How We Feel</em> app, which tracks emotional states—an approach I adapted specifically to the shopping context.</p>
  
    <p>This project was developed as part of a Critical UX course, where I addressed a social issue through the full design process, from ideation to prototyping and user testing. My contributions included:</p>
    <ul>
      <li>Identifying the problem space of emotional manipulation in e-commerce</li>
      <li>Prototyping two design iterations in Figma based on feedback (mobile app → browser extension)</li>
      <li>Creating a component library with reusable components</li>
    </ul>
  
    <p>The final prototype provides users with emotional check-ins, shopping insights over time, and a reflection log to build healthier habits. It aligns with critical UX principles by addressing the ethical and emotional dimensions of digital shopping.</p>
  `,  */
    tags: ['User Experience', 'UI Design'],
/*    links: [
      {
        name: 'Full Project Report',
        url: 'https://drive.google.com/file/d/1BDKPuykMhD95138KetX16jxPQ6wETknl/view?usp=sharing]',
      },
      {
        name: 'Figma Prototype Mobile',
        url: 'https://www.figma.com/design/Ky2i0HFZHZm8wT6bxW2sNa/Critical-UX-Prototype?node-id=0-1&p=f',
      },
      {
        name: 'Figma Browser Extension',
        url: 'https://www.figma.com/design/Ky2i0HFZHZm8wT6bxW2sNa/Critical-UX-Prototype?node-id=72-1129&t=dyFUWLGdJWarxFnk-1',
      },
    ]*/
  },
  'fridge-it': {
    title: 'Fridge-It!',
    subtitle: 'Designing a sustainable food sharing system',
    images: ['/images/fridge.png','/images/fridge1.png','/images/fridge2.png','/images/fridge3.png'],
    summary: 'A UX sprint to design a hybrid system combining physical labels and a companion app to reduce food waste.',
    info: {
    tasks: ['UX Design', 'Prototype', 'Protocol Design'],
    tools: ['Figma'],
    team: ['4 Members'],
    role: ['Ideation & Brainstorming', 'Protocol Design', 'Results Analysis'],
    timeline: '1 week sprint (Dec 2024)'
    },
    sections: [
      // ——— Non-step sections ———
      {
        title: 'Background',
        body: `
         <p><strong>Fridge-It!</strong> is a UX design sprint project aimed at improving how students share and consume excess food in shared kitchens. Over the course of one week, our team conceptualized, designed and tested a food-sharing app concept addressing concerns around trust, hygiene, and social norms.</p>
  `
      },
     /* {
        title: 'A/B Testing',
        body: ``
      },*/
      {
        title: 'Contributions',
        body: `
          <p>I led the ideation and brainstorming sessions, helping the team decide on a design direction. I also authored the full user testing protocol and served as the lead facilitator, conducting sessions with 5 participants. Due to time limitations, I wrote the protocol in one day. Our protocol explored the minimum information users need to feel comfortable taking food left by others.</p>

  <p>The protocol was awarded <strong>Best Testing Protocol</strong> in the course among 8 other teams, recognizing the clarity and depth of our approach to understanding user behavior in shared spaces.</p>
`
      },
    ],
    description: ``,
    tags: ['User Experience', 'Design Sprint'],
    links: [
      {
        name: 'Full Protocol',
        url: 'https://drive.google.com/file/d/1aV_hem32iiPsm9CYEX0EXfuRgZO_NuP8/view?usp=sharing',
      },
      {
        name: 'Full Project Report',
        url: 'https://drive.google.com/file/d/1iFIBotbjbXXujBsxEXKYZSgGDDwSaVo7/view?usp=sharing',
      },
    ],
  },
  'personality perception': {
    title: 'Conference Paper: Personality Perception in Human Videos Altered by Motion Transfer Networks',
    images: ['/images/personality-paper.png','/images/personality1.png'],
    summary: '1st author of the conference paper published in Computer & Graphics.',
    description: `
    <p>As part of my Senior Research Project during my Bachelor's, I was the first author of the conference paper titled <em>"Personality Perception in Human Videos Altered by Motion Transfer Networks"</em>, published in <em>Computers & Graphics</em>.</p>

    <p>The paper explored how movement and appearance affect the perceived personality of virtual humans, guided by three core research questions:</p>
    <ol>
      <li>Can motion transfer networks alter personality perception in human videos?</li>
      <li>Do appearance and motion-based cues similarly impact personality expression?</li>
      <li>Do adjustments made by motion transfer networks influence each personality factor similarly?</li>
    </ol>

    <p><strong>Contributions:</strong></p>
    <ul>
      <li>Ran 2 user studies on personality perception using videos generated by the Thin-Plate Spline motion model</li>
      <li>Generated insights on personality expression in virtual humans:</li>
      <ul>
        <li>Motion and realism play a significant role in perceived personality</li>
        <li>Appearance plays a less significant but still visible role</li>
      </ul>
    </ul>
    `,
    tags: ['Academic Research'],
    links: [
      { name: 'Read Full Paper', url: 'https://arxiv.org/abs/2401.14733' },
    ],
  },
  'code-smells': {
    title: 'Journal Paper: A Taxonomy Towards Inline Code Comment Smells',
    images: ['/images/taxonomy.png'],
    summary: '2nd author of the journal paper published in Empirical Software Engineering.',
    description: `
      <p>I co-authored the journal paper <em>"A Taxonomy Towards Inline Code Comment Smells"</em> as the second author. The paper was accepted for publication in <em>Empirical Software Engineering</em>.</p>

      <p>We proposed a taxonomy of inline code comment smells, consisting of <strong>11 categories</strong>, and examined their frequency in real-world software projects. To evaluate the taxonomy, we <strong>manually labeled 2447 inline comments</strong> from eight open-source repositories (4 Java and 4 Python), conducted an <strong>online survey</strong>, and submitted pull requests to gather developer feedback.</p>

      <p><strong>My contributions:</strong></p>
      <ul>
        <li>Manual labeling of comment smells across multiple codebases</li>
        <li>Analyzing survey responses from software engineers</li>
        <li>Discussing and interpreting the findings to validate the taxonomy</li>
      </ul>
      `,
    tags: ['Academic Research'],
    links: [
      { name: 'Read Full Paper', url: 'https://link.springer.com/article/10.1007/s10664-023-10425-5' },
    ],
  },
  'starcraft-ai': {
    title: 'Starcraft AI Bot Design for Zerg Race',
    images: ['/images/starcraft3.png','/images/starcraft.png', '/images/starcraft1.png','/images/starcraft2.png',],
    summary: 'Designed a real-time AI bot for Zerg race using behavior trees and blackboard architecture.',
    description: `
    <p>Built as a team project, Zerg Strategy AI Bot for StarCraft adapts dynamically to enemy strategies using finite state machines and behavior trees. I contributed to the <strong>design and implementation of the unit behavior trees</strong>, helping structure decision logic across drones, larva, defensive, and offensive units. You can find them on this page.</p>
    
    <p>We used a modular architecture with a central Brain system and blackboard-style shared memory to manage build orders, scouting, and combat behaviors. I also worked on <strong>testing, balancing, and documentation</strong>, ensuring the bot reacted realistically in different matchups.</p>
    
    <p><strong>Key techniques:</strong> behavior trees, blackboard architecture, finite state machines, BWAPI debugging.</p>
    `,
    tags: ['Game Design'],
    links: [],
  },
  'macrame-data': {
    title: 'Exploring Expressivity of Macrame in Data Physicalization',
    images: ['/images/macrame.png','/images/macrame2.png','/images/macrame1.png'],
    summary: "A cross-disciplinary workshop series exploring macramé as a medium for data physicalization, where I led the protocol design and co-authored the research paper on findings.",
    description: `
    <p><strong>Macramé for Data Physicalization</strong> is a cross-disciplinary research project that investigates how fiber art can serve as a medium for tangible data representation. We brought together macramé artists and design students in a series of workshops, where participants collaboratively explored ways to encode quantitative and relational data using knots, textures, and structure.</p>
    
    <p>I was responsible for designing the full workshop protocol — including learning goals, hands-on activities, and facilitation guidelines — and I served as the lead facilitator during the sessions. I also co-authored the final research paper, contributing to the thematic analysis of participant outputs and the synthesis of ten design implications that emphasize macramé’s expressiveness and its potential for multimodal data encoding.</p>
    
    <p>Despite time and skill barriers, the workshops revealed high levels of participant engagement and creativity. This work demonstrates how traditional craft techniques like macramé can open up new material-driven approaches to data storytelling and critical making.</p>
    `,    
    tags: ['Data Physicalization', 'Academic Research'],
    links: [
      { name: 'Read Full Report', url: 'https://drive.google.com/file/d/1Pti9PzGqJE5PmjqmkgFPzXzP3gxII8hM/view?usp=sharing' },
    ],
  },
  'data-catcher': {
    title: 'Data Catcher: Physicalizing Sleep Data',
    images: ['/images/catcher2.png','/images/catcher3.png','/images/catcher1.png',],
    summary: "A dreamcatcher-inspired physicalization of my sleep and dream data, designed to explore patterns and improve sleep habits.",
    description: `
    <p><strong>The Data Catcher</strong> is a data physicalization project that transforms 20 days of my personal sleep data into a tangible, dreamcatcher-inspired object. It visualizes metrics like sleep duration, sleep stages, dream count and intensity, and both subjective and smartwatch-provided sleep scores.</p>

    <p>As the sole designer and fabricator, I led this project from ideation to final construction. I formulated the data questions, designed multiple concepts, and created a 3D dream catcher model that incorporates a visual hierarchy—placing sleep quality at the top and dream-related data at the bottom—to improve readability.</p>

    <p>This project was developed as part of a physicalization course and received positive feedback for its creativity and aesthetic coherence. I iteratively refined the prototype based on critique, ultimately producing a layered, tactile object that invites reflection on the relationship between emotion, rest, and technology.</p>
  `,
    tags: ['Data Physicalization'],
    links: [],
  },
  'soul-dragon-knight': {
    title: 'Soul Dragon Knight – Multiplayer Game',
    images: ['/images/soul-dragon.png'],
    summary: "A multiplayer co-op game where players must communicate across two invisible worlds to defeat enemies.",
    description: `
      <p><strong>Soul Dragon Knight</strong> is a multiplayer game developed by a team of five. I contributed to both the <strong>gameplay design</strong> and the creation of <strong>pixel art assets</strong> that enrich the game's visual environment.</p>

      <p>The game is set in two parallel dimensions: the <em>human world</em> and the <em>soul world</em>. Each player exists in one world and cannot see the enemies in their own dimension—only their teammate can. This mechanic requires constant communication between players to locate and defeat unseen threats.</p>

      <p>We used distinct color palettes to visually differentiate the two worlds and enhance the player's sense of immersion and orientation.</p>
    `,
    tags: ['Game Design'],
    links: [
      { name: 'Watch Game Trailer!', url: 'https://www.youtube.com/watch?v=YHW5pdTlZs4' },
    ],
  },
  'paintings': {
    title: 'Series of Paintings',
    summary: null,
    images: [
    //  '/images/paint14.jpg','/images/paint.png','/images/paint13.jpg','/images/paint15.jpg','/images/paint7.png','/images/paint6.png','/images/paint8.png','/images/paint4.jpg','/images/paint9.png','/images/paint5.jpg','/images/paint10.png','/images/paint1.jpg','/images/paint12.jpg','/images/paint3.jpg','/images/paint2.jpg','/images/paint16.jpg'
    ],
    description:`

 <section class="painting-intro">
  <p class="intro-text">
    I love making art! I've been drawing ever since I learned how to hold a pen and discovered oil painting during my university drawing classes. 
    Since then, I create art to make my inner child happy.
  </p>
  <p class="intro-text">
    I’ve explored pastels, markers, watercolor, linogravure, and digital art, but oil painting remains my favorite. 
    I especially enjoy using vibrant color palettes to paint landscapes and animals the most.
  </p>
</section>

    <section class="painting-gallery">
    <div class="painting-grid">
      <img src="/images/paint14.jpg" alt="Painting 14">
      <img src="/images/paint.png" alt="Painting">
      <img src="/images/paint13.jpg" alt="Painting 13">
      <img src="/images/paint15.jpg" alt="Painting 15">
      <img src="/images/paint7.png" alt="Painting 7">
      <img src="/images/paint6.png" alt="Painting 6">
      <img src="/images/paint8.png" alt="Painting 8">
      <img src="/images/paint4.jpg" alt="Painting 4">
      <img src="/images/paint9.png" alt="Painting 9">
      <img src="/images/paint5.jpg" alt="Painting 5">
      <img src="/images/paint10.png" alt="Painting 10">
      <img src="/images/paint1.jpg" alt="Painting 1">
      <img src="/images/paint12.jpg" alt="Painting 12">
      <img src="/images/paint3.jpg" alt="Painting 3">
      <img src="/images/paint2.jpg" alt="Painting 2">
      <img src="/images/paint16.jpg" alt="Painting 16">
    </div>
  <div id="imageModal" class="modal">
    <span class="close">&times;</span>
    <img class="modal-content" id="modalImage" alt="Expanded Painting">
  </div>
  
  </section>


    `,
    tags: ['Paintings'],
    links: [],
  },
};


function ProjectPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const project = projectData[id];

  if (!project) return <div className="project-page"><p>Project not found</p></div>;

useEffect(() => {
    const track = document.getElementById('carouselTrack');
    const prevBtn = document.getElementById('prevBtn');
    const nextBtn = document.getElementById('nextBtn');
    const progressBar = document.getElementById('progressBar');

    if (!track || !prevBtn || !nextBtn) return;

    let scrollPosition = 0;
    const mockups = document.querySelectorAll('.iphone-mockup');
    const mockupWidth = 280; 
    const gap = 30;
    const scrollAmount = mockupWidth + gap;

    function updateButtonStates() {
        const maxScroll = (mockups.length * scrollAmount) - track.parentElement.offsetWidth;
        prevBtn.disabled = scrollPosition <= 0;
        nextBtn.disabled = scrollPosition >= maxScroll;

        const progress = (scrollPosition / maxScroll) * 100;
        progressBar.style.width = Math.min(Math.max(progress, 0), 100) + '%';
    }

    function scroll(direction) {
        const containerWidth = track.parentElement.offsetWidth;
        const currentMockupWidth = mockups[0].offsetWidth;
        const currentGap = parseInt(getComputedStyle(track).gap);
        const currentScrollAmount = currentMockupWidth + currentGap;

        scrollPosition += direction * currentScrollAmount;

        const maxScroll = (mockups.length * (currentMockupWidth + currentGap)) - containerWidth;
        scrollPosition = Math.max(0, Math.min(scrollPosition, maxScroll));

        track.style.transform = `translateX(-${scrollPosition}px)`;
        updateButtonStates();
    }

    prevBtn.onclick = () => scroll(-1);
    nextBtn.onclick = () => scroll(1);

    // --- Touch swipe ---
    let touchStartX = 0;
    let isDragging = false;
    let startScrollPosition = 0;

    track.addEventListener('touchstart', (e) => {
        touchStartX = e.touches[0].clientX;
        startScrollPosition = scrollPosition;
        isDragging = true;
    });

    track.addEventListener('touchmove', (e) => {
        if (!isDragging) return;
        const diff = touchStartX - e.touches[0].clientX;

        const containerWidth = track.parentElement.offsetWidth;
        const maxScroll = (mockups.length * (mockups[0].offsetWidth + parseInt(getComputedStyle(track).gap))) - containerWidth;

        scrollPosition = Math.max(0, Math.min(startScrollPosition + diff, maxScroll));
        track.style.transform = `translateX(-${scrollPosition}px)`;
    });

    track.addEventListener('touchend', () => {
        isDragging = false;
        updateButtonStates();
    });

    // --- Mouse drag ---
    let mouseStartX = 0;
    let isMouseDragging = false;

    track.addEventListener('mousedown', (e) => {
        mouseStartX = e.clientX;
        startScrollPosition = scrollPosition;
        isMouseDragging = true;
        track.style.cursor = 'grabbing';
    });

    document.addEventListener('mousemove', (e) => {
        if (!isMouseDragging) return;
        const diff = mouseStartX - e.clientX;

        const containerWidth = track.parentElement.offsetWidth;
        const maxScroll = (mockups.length * (mockups[0].offsetWidth + parseInt(getComputedStyle(track).gap))) - containerWidth;

        scrollPosition = Math.max(0, Math.min(startScrollPosition + diff, maxScroll));
        track.style.transform = `translateX(-${scrollPosition}px)`;
    });

    document.addEventListener('mouseup', () => {
        if (isMouseDragging) {
            isMouseDragging = false;
            track.style.cursor = 'grab';
            updateButtonStates();
        }
    });

    // Keyboard navigation
    document.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') scroll(-1);
        if (e.key === 'ArrowRight') scroll(1);
    });

    // Initialize
    updateButtonStates();

    window.addEventListener('resize', () => {
        scrollPosition = 0;
        track.style.transform = 'translateX(0)';
        updateButtonStates();
    });

    return () => {
        // cleanup not required for passive listeners, but safe
    };
}, []);




  useEffect(() => {
  const modal = document.getElementById("imageModal");
  const modalImg = document.getElementById("modalImage");
  const closeBtn = document.querySelector(".close");

  if (!modal || !modalImg || !closeBtn) return;

  const images = document.querySelectorAll(".painting-grid img, .levels-gallery img");
  const openModal = (img) => {
    modal.style.display = "block";
    modalImg.src = img.src;
    modalImg.alt = img.alt;
  };
  const closeModal = () => { modal.style.display = "none"; };

  images.forEach(img => img.addEventListener("click", () => openModal(img)));
  closeBtn.addEventListener("click", closeModal);
  modal.addEventListener("click", (e) => {
    if (e.target === modal) closeModal();
  });

  // cleanup on unmount
  return () => {
    images.forEach(img => img.removeEventListener("click", () => openModal(img)));
    closeBtn.removeEventListener("click", closeModal);
    modal.removeEventListener("click", (e) => {
      if (e.target === modal) closeModal();
    });
  };
}, []);

  return (
    <div className="project-page">
    <button className="back-button" onClick={() => navigate('/')}>← Back</button>
    
    <h1>{project.title}</h1>
    {project.subtitle && <h2 className="project-subtitle">{project.subtitle}</h2>}
 
    <div className="tags">
      {project.tags.map((tag, idx) => (
        <span key={idx} className="tag">{tag}</span>
      ))}
    </div>

    <div className="project-content">
    <div className={`image-gallery ${!project.description ? 'grid' : ''}`}>
      {project.images.map((img, idx) => (
        <img key={idx} src={img} alt={`${project.title} ${idx}`} />
      ))}
    </div>
    {project.info && (
      <div className="info-card">
        <div>
          <h4>TASKS</h4>
          {project.info.tasks.map((t, i) => <p key={i}>{t}</p>)}
        </div>
        <div>
          <h4>TEAM</h4>
          {project.info.team.map((t, i) => <p key={i}>{t}</p>)}
        </div>
        <div>
          <h4>CONTRIBUTIONS</h4>
          {project.info.role.map((t, i) => <p key={i}>{t}</p>)}
        </div>
        <div>
          <h4>TIMELINE</h4>
          <p>{project.info.timeline}</p>
        </div>
      </div>
    )}

      <div className="project-info">
        {project.sections && (

          <section className="sections">
            {project.sections.map((s, i) => (
              <div key={i} className="section-row">
                <div className="section-side">
                  <div className="section-title">{s.title}</div>
                 {/* {s.subtitle && <div className="section-sub">{s.subtitle}</div>} */}
                </div>

                {s.process && (
                  <div className="process-strip">
                    {s.process.map((p, idx) => (
                      <div key={idx} className="process-step">
                        <div className="process-number">{p.step}</div>
                        <div className="process-phase">{p.phase}</div>
                        {p.items.map((it, j) => (
                          <div key={j} className="process-item">{it}</div>
                        ))}
                        {idx < s.process.length - 1 && <div className="process-arrow">›</div>}
                      </div>
                    ))}
                  </div>
                )}

                {!s.process && s.body && (
                  <div className="section-body" dangerouslySetInnerHTML={{ __html: s.body }} />
                )}
              </div>
            ))}
          </section>
        )}

        {project.description && (
          <div
            className="description"
            dangerouslySetInnerHTML={{ __html: project.description }}
          />
        )}

      {project.links && (
          <div className="link-buttons">
            {project.links.map((link, idx) => (
              <a key={idx} href={link.url} target="_blank" rel="noreferrer">
                <button className="visit-button">{link.name}</button>
              </a>
            ))}
          </div>
        )}
      </div>
    </div>
    
    </div>

  );
}

export default ProjectPage;
